// extracted by mini-css-extract-plugin
module.exports = {"midGreyColour":"#868686","container":"Buddies_container__XsH8K","imageSlide":"Buddies_imageSlide__3Lrnw"};